<template>
  <div class="article">
    <div class="layout__content__header layout__content__header--white">
      <app-back
        :text="'zpetNaVsechnyNovinky'"
        :route="{
          name: 'articles',
          params: {
            customerId: selectedCustomer.customerId,
            projectId: selectedProject.projectId
          }
        }"
      />
      <h1>{{ item.nadpis }}</h1>
    </div>
    <div class="layout__content__content pt-5">
      <div class="news__item__text" v-html="item.text" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Back from "@/components/back.vue";

export default {
  components: {
    "app-back": Back
  },
  data() {
    return {
      articleId: this.$route.params.id,
      articleUrl: this.$route.query.url,
      selectedProject: JSON.parse(localStorage.getItem("selectedProject")),
      selectedCustomer: JSON.parse(localStorage.getItem("selectedCustomer")),
      item: []
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    locale() {
      this.loadArticle();
    }
  },
  created() {
    this.loadArticle();
  },
  methods: {
    loadArticle() {
      axios
        .get(
          process.env.VUE_APP_APICMS +
            "/" +
            this.locale +
            "/article" +
            this.articleUrl,
          { crossdomain: true }
        )
        .then(response => {
          this.item = response.data[0];
        })
        .catch(() => {
          this.item = {};
        });
    }
  }
};
</script>

<style scoped></style>
